<template>
  <BaseDataIterator :service="fetchData">
    <template #default="dataIteratorProps">
      <div key="grid_view" class="p-4 bg-gray-100">
        <BaseGrid :columns="4" class="gap-4">
          <InstagramAdPostCard
            v-for="adPost in dataIteratorProps.data"
            :key="adPost.id"
            :ad-post="adPost"
          />
        </BaseGrid>
      </div>
    </template>
  </BaseDataIterator>
</template>

<script>
import { accountInstagramAdPostsClient } from '@/api/clients';
import InstagramAdPostCard from './InstagramAdPostCard.vue';

export default {
  components: {
    InstagramAdPostCard,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
    since: {
      type: String,
      default: '',
    },
    until: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      included: [],
    };
  },
  computed: {
    queryParams() {
      return {
        ...(this.since ? { filter: { created_between: `${this.since},${this.until}` } } : {}),
      };
    },
  },
  methods: {
    fetchData(params) {
      return accountInstagramAdPostsClient
        .list(this.accountId, { ...params, ...this.queryParams, page_size: 20 })
        .then(({ data, meta, included }) => {
          return Promise.resolve({
            data: this.transformFacebookAdsToInstagramAds(data, included?.instagramStories || []),
            meta,
          });
        });
    },
    transformFacebookAdsToInstagramAds(ads, stories = []) {
      return ads.reduce((carry, ad) => {
        return [
          ...carry,
          ...ad.adcreatives
            .map((adcreative) => {
              const story =
                stories.find((story) => story.id === adcreative.effective_instagram_story_id) ||
                null;

              return story?.status === 'ok' ? story.data : null;
            })
            .filter(Boolean),
        ];
      }, []);
    },
  },
};
</script>
